import tippy from "tippy.js";

export function initContentTooltips(tooltipClass, options) {
    const contentTooltips = document.querySelectorAll(tooltipClass);

    if (contentTooltips) {
        contentTooltips.forEach((tooltip) => {
            let target = null;
            let content = null;

            Array.from(tooltip.children).forEach((children) => {
                if (children.hasAttribute("data-tooltip-target")) {
                    target = children;
                }

                if (children.hasAttribute("data-tooltip-content")) {
                    content = children.innerHTML;
                }
            })

            if (!tooltip.classList.contains("tooltip-initialized")) {
                tippy(target, Object.assign({
                    theme: "light",
                    ignoreAttributes: true,
                    trigger: "mouseenter",
                    interactive: true,
                    allowHTML: true,
                    content: content,
                    appendTo: () => document.body,
                }, options));

                tooltip.classList.add("tooltip-initialized");
            }
        });     
    }
}
